import React from 'react';
import { IconButton } from 'wix-style-react';
import ChevronLeft from 'wix-ui-icons-common/ChevronLeft';
import ChevronRight from 'wix-ui-icons-common/ChevronRight';
import ReactPaginate from 'react-paginate';
import s from './pagination.scss';

const Pagination = ({ pageCount, currentPage, onPageChange }) => (
  <div className={s.root} data-hook="explore-pagination">
    <ReactPaginate
      previousLabel={
        <IconButton
          as="button"
          skin="light"
          dataHook="prev-page-button"
          className={currentPage > 1 ? '' : s.hide}
        >
          <ChevronLeft />
        </IconButton>
      }
      nextLabel={
        <IconButton
          as="button"
          skin="light"
          dataHook="next-page-button"
          className={currentPage < pageCount ? '' : s.hide}
        >
          <ChevronRight />
        </IconButton>
      }
      forcePage={currentPage - 1}
      breakLabel="..."
      breakClassName="break-me"
      pageCount={pageCount}
      marginPagesDisplayed={3}
      pageRangeDisplayed={3}
      onPageChange={onPageChange}
      containerClassName={s.pagination}
      activeClassName={s.active}
      pageClassName={s.paginationItem}
      disableInitialCallback={true}
    />
  </div>
);

export default Pagination;
